export const TEST_ID = 'servicePhotosField';

export const ACCEPT_FILE_TYPES = 'image/jpeg,image/png,image/heic';
